import React from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import MobileNotFound from '../../components/mobile/NotFound';
import PcNotFound from '../../components/pc/NotFound';
import MobileContainer from './mobile/Container';
import PcContainer from './pc/Container';
import MobileDetail from './mobile/Detail';
import PcDetail from './pc/Detail';
import MobileSubmitted from './mobile/Submitted';
import PcSubmitted from './pc/Submitted';
import MobileExpired from './mobile/Expired';
import PcExpired from './pc/Expired';
import MobileSuccess from './mobile/Success';
import PcSuccess from './pc/Success';

export const history = createBrowserHistory({
    basename:
        process.env.NODE_ENV === 'production'
            ? '/hire/otps/interview-questionnaire'
            : '/interview-questionnaire'
});

window.routerHistory = history;

export const path = {
    404: '/404',
    detail: (questionnaire_token: string) => `/questionnaire/${questionnaire_token}/detail`,
    success: (questionnaire_token: string) => `/questionnaire/${questionnaire_token}/success`,
    hasSubmitted: (questionnaire_token: string) =>
        `/questionnaire/${questionnaire_token}/hasSubmitted`,
    expired: (questionnaire_token: string) => `/questionnaire/${questionnaire_token}/expired`
};

export interface BaseRouteProps {
    isMobile: boolean;
}

const { useMemo } = React;
const BaseRoute: React.FC<BaseRouteProps> = ({ isMobile }) => {
    const NotFound = useMemo(() => (isMobile ? MobileNotFound : PcNotFound), [isMobile]);
    const Container = useMemo(() => (isMobile ? MobileContainer : PcContainer), [isMobile]);
    const Submitted = useMemo(() => (isMobile ? MobileSubmitted : PcSubmitted), [isMobile]);
    const Detail = useMemo(() => (isMobile ? MobileDetail : PcDetail), [isMobile]);
    const Expired = useMemo(() => (isMobile ? MobileExpired : PcExpired), [isMobile]);
    const Success = useMemo(() => (isMobile ? MobileSuccess : PcSuccess), [isMobile]);
    return (
        <Router history={history}>
            <Switch>
                <Route path="/questionnaire/:questionnaire_token">
                    <Container>
                        <Switch>
                            <Route path="/questionnaire/:questionnaire_token/detail">
                                <Detail />
                            </Route>
                            <Route path="/questionnaire/:questionnaire_token/hasSubmitted">
                                <Submitted />
                            </Route>
                            <Route path="/questionnaire/:questionnaire_token/expired">
                                <Expired />
                            </Route>
                            <Route path="/questionnaire/:questionnaire_token/success">
                                <Success />
                            </Route>
                        </Switch>
                    </Container>
                </Route>
                <Route path={path[404]}>
                    <NotFound />
                </Route>
                <Redirect to={path[404]} />
            </Switch>
        </Router>
    );
};

export default BaseRoute;
